(function($) {
    'use strict';

    var Tooltip = function(el, options) {
        this.settings = options;
        this.$el = $(el);

        this.settings = $.extend(
            {
                stick: false,
                mouseover: false,
                title: null,
                description: null
            },
            this.settings,
            this.$el.data()
        );

        this.init();
    };

    Tooltip.prototype = {
        $tooltip: null,

        init: function() {
            var that = this;

            that.createTooltip();

            that.bindEvents();
        },

        bindEvents: function() {
            var that = this;

            if (that.settings.mouseover) {
                that.$el.on('mouseover', function() {
                    that.display();
                });
            }

            that.$el.on('click', function(e) {
                if (that.$tooltip.is(':visible')) {
                    that.hide();
                } else {
                    that.display();
                }
                e.preventDefault();
            });

            if (!that.settings.stick) {
                that.$el.on('mouseout', function() {
                    that.hide();
                });
            }

            that.$tooltip.find('.tooltip-close').on('click', function() {
                that.hide();
            });

            $('body, .accordion-title').on('click', function(e) {
                var $target = $(e.target);

                if (
                    $target.is(that.$el) ||
                    $target.is(that.$tooltip) ||
                    that.$tooltip.has($target).length > 0
                ) {
                    return;
                }

                that.hide();
            });

            $(window).resize(function() {
                that.position();
            });
        },

        createTooltip: function() {
            var that = this,
                $tooltip = $('<div>').addClass('tooltip'),
                $wrapper = $('<div>').addClass('tooltip-content-wrapper'),
                $content = $('<div>').addClass('tooltip-content'),
                $arrow = $('<div>').addClass('tooltip-arrow'),
                $close = $('<div>').addClass(
                    'icon-validation-cross tooltip-close hide show-xs'
                );

            if (that.settings.title) {
                $content.append(
                    $('<h4>').addClass('tooltip-title').text(that.settings.title)
                );
            }
            if (that.settings.description) {
                $content.append($('<p>').text(that.settings.description));
            }

            $tooltip.append($wrapper);
            $wrapper.append($content);
            $wrapper.append($arrow);
            $wrapper.append($close);
            $('body').append($tooltip);

            that.$tooltip = $tooltip;
        },

        display: function() {
            var that = this;

            that.position();
            that.$tooltip.show();
        },

        hide: function() {
            var that = this;

            that.$tooltip.hide();
        },

        position: function() {
            var that = this,
                position = that.getPosition();

            that.$tooltip.css({
                left: position.left,
                top: position.top
            });
        },

        getPosition: function() {
            var that = this,
                offset = that.$el.offset(),
                height = that.$el.height(),
                width = that.$el.width(),
                tooltipWidth = that.$tooltip.outerWidth(),
                windowWidth = $(window).width(),
                arrowHeight = 11,
                position = {};

            position.left = offset.left - tooltipWidth / 2 + width / 2;
            position.top = offset.top + height + arrowHeight;

            if (position.left < 10) {
                position.left = 10;
            } else if (tooltipWidth + position.left > windowWidth) {
                position.left =
                    position.left + (windowWidth - (tooltipWidth + position.left));
            }

            return position;
        }
    };

    $.fn.tooltip = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('tooltip');

            if (!data) {
                $this.data('tooltip', (data = new Tooltip(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };

    $.fn.tooltip.Constructor = Tooltip;
})(jQuery);
